<template>
    <div>
        <div v-for="babyNum in range(response['BIRTH_NUMBER'])" :key="babyNum" class="mb-4">
            <div v-if="response['BIRTH_NUMBER'] > 1" class="mb-2 fw-bold text-decoration-underline">
                {{ props.question.header[participant.language] }}{{ babyNum }}
            </div>
            <div v-if="props.question.text != null" class="row mb-2">
                <div class="col">{{ props.question.text[participant.language] }}</div>
            </div>
            <div class="row">
                <div class="col-6">
                    <div class="input-group">
                        <select 
                            class="form-select" 
                            :name="props.question.variable + '_' + babyNum"
                            :id="props.question.variable + '_' + babyNum"
                            @change="event => updateWeight(babyNum, 'pounds', event, response)"
                        >
                            <option value>Select ...</option>
                            <option v-for="option in props.question.select[0].options" 
                                    :value="option.value"
                                    :selected="calculatePounds(babyNum, response) === option.value"
                                    :key="option.value"
                            >
                                {{ option.label[participant.language] }}
                            </option>
                        </select>
                        <span class="input-group-text">{{ props.question.unit[0][participant.language] }}</span>
                    </div>
                </div>
                <div class="col-6">
                    <div class="input-group">
                        <select 
                            class="form-select" 
                            :name="props.question.variable + '_' + babyNum"
                            :id="props.question.variable + '_' + babyNum"
                            @change="event => updateWeight(babyNum, 'ounces', event, response)"
                        >
                            <option value>Select ...</option>
                            <option v-for="option in props.question.select[1].options" 
                                    :value="option.value"
                                    :selected="calculateOunces(babyNum, response) === option.value"
                                    :key="option.value"
                            >
                                {{ option.label[participant.language] }}
                            </option>
                        </select>
                        <span class="input-group-text">{{ props.question.unit[1][participant.language] }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script setup>
    import { ref } from 'vue'
    import { storeToRefs } from 'pinia'
    import { useSurveysStore } from '../../../stores/surveys'
    import debounce from "lodash/debounce"

    const { saveResponseBabies, setError } = useSurveysStore()
    const { participant, response } = storeToRefs(useSurveysStore())
    const props = defineProps(['question'])

    function range(n) {
        return [...Array(n).keys()].map(x => x + 1);
    }

    function calculatePounds(babyNum, response) {
        let jsonResponse

        if (response[props.question.variable] && typeof response[props.question.variable] === 'string') {
            try {
                jsonResponse = JSON.parse(response[props.question.variable])
            } catch (e) {
                console.dir(e)
                return 0
            }
        } else if (typeof response[props.question.variable] === 'object' && response[props.question.variable] !== null) {
            jsonResponse = response[props.question.variable]
        } else {
            return 0
        }


        if (jsonResponse['baby' + babyNum] == null) {
            return null
        } else if ([888, 999].includes(jsonResponse['baby' + babyNum])) {
            return jsonResponse['baby' + babyNum]
        } else {
            return Math.floor(jsonResponse['baby' + babyNum]/16)
        }
    }

    function calculateOunces(babyNum, response) {
        let jsonResponse

        if (response[props.question.variable] && typeof response[props.question.variable] === 'string') {
            try {
                jsonResponse = JSON.parse(response[props.question.variable])
            } catch (e) {
                console.dir(e)
                return 0
            }
        } else if (typeof response[props.question.variable] === 'object' && response[props.question.variable] !== null) {
            jsonResponse = response[props.question.variable]
        } else {
            return 0
        }

        if (jsonResponse['baby' + babyNum] == null) {
            return null
        } else if ([888, 999].includes(jsonResponse['baby' + babyNum])) {
            return jsonResponse['baby' + babyNum]
        } else {
            if (jsonResponse['baby' + babyNum] >= 16) {
                return jsonResponse['baby' + babyNum] % 16
            } else {
                return jsonResponse['baby' + babyNum]
            }
        }
    }

    function updateWeight(babyNum, unit, event, response) {
        let jsonResponse

        if (response[props.question.variable] && typeof response[props.question.variable] === 'string') {
            try {
                jsonResponse = JSON.parse(response[props.question.variable])
            } catch (e) {
                console.dir(e)
                return 0
            }
        } else if (typeof response[props.question.variable] === 'object' && response[props.question.variable] !== null) {
            jsonResponse = response[props.question.variable]
        } else {
            jsonResponse = {}
        }

        const value = parseInt(event.target.value)
        let babyValue  = isNaN(value) ? event.target.value : value

        if ([888, 999].includes(babyValue)) {
            jsonResponse['baby' + babyNum] = babyValue
            saveResponseBabies(props.question.variable, jsonResponse)
            return
        }

        let oldTotalOunces = jsonResponse['baby' + babyNum] ?? 0
        let oldPounds = Math.floor(oldTotalOunces/16)
        let oldOunces = oldTotalOunces % 16

        if (unit == 'pounds') {
            if (babyValue > oldPounds) {
                jsonResponse['baby' + babyNum] = oldTotalOunces + ((babyValue - oldPounds) * 16)
            }
            if (oldPounds > babyValue) {
                jsonResponse['baby' + babyNum] = oldTotalOunces - ((oldPounds - babyValue) * 16)
            }
        }
        if (unit == 'ounces') {
            jsonResponse['baby' + babyNum] = (oldPounds * 16) + parseInt(babyValue)
        }

        setError('')
        for (let i = 1; i <= response['BIRTH_NUMBER']; i++) {
            const key = 'baby'+ i
            if (jsonResponse[key] !== undefined && jsonResponse[key] < 8) {
                setError('Please enter a weight of at least 8 oz.')
                return
            }
        }

        saveResponseBabies(props.question.variable, jsonResponse)
    }
</script>